<template>
  <v-card v-resize="onResize" :height="height">
    <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-checkbox
        v-model="selectAll"
        :label="numberSelected"
        @click.stop="selectAllTeam"
        :indeterminate="indeterminate"
        hide-details
      ></v-checkbox>

      <v-toolbar-title class="hidden-sm-and-down ml-5">
        Products
      </v-toolbar-title>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="primary"
      ></v-progress-linear>

      <v-spacer></v-spacer>

      <v-btn :disabled="disable" fab small color="primary" class="mr-4">
        <v-icon @click="dialog = true">mdi-email</v-icon>
      </v-btn>
      <v-btn
        :disabled="disable"
        fab
        small
        color="primary"
        class="hidden-sm-and-down mr-4"
      >
        <v-icon>mdi-cloud-download</v-icon>
      </v-btn>
      <!-- <v-btn
        :disabled="disable"
        fab
        small
        color="primary"
        class="hidden-sm-and-down mr-6"
      >
        <v-icon @click="downloadPdf">mdi-printer</v-icon>
      </v-btn> -->

      <v-select
        v-model="team"
        :items="items"
        label="Select Team"
        prepend-icon="mdi-account-group"
        @change="selectTeam"
        hide-details
        class="hidden-sm-and-down"
      ></v-select>

      <v-text-field
        v-model="search"
        label="Search Employees"
        prepend-icon="mdi-magnify"
        v-on:keyup="searchProducts"
        clearable
        @click:clear="clearMessage"
        hide-details
        class="hidden-sm-and-down pl-4"
      />

      <v-menu :nudge-width="200" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="primary"
            v-on="on"
            class="hidden-md-and-up mr-4"
          >
            <v-icon dark>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-subheader>SELECT OPTION</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item :disabled="disable">
              <v-list-item-icon>
                <v-icon :disabled="disable" color="primary">
                  mdi-cloud-download
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Download Selected
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <!-- <v-list-item :disabled="disable" @click="downloadPdf">
              <v-list-item-icon>
                <v-icon :disabled="disable" color="primary">mdi-printer</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Print
              </v-list-item-content>
            </v-list-item> -->
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="primary"
            v-on="on"
            class="hidden-md-and-up"
          >
            <v-icon dark>mdi-magnify</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-subheader>SEARCH</v-subheader>
            <v-divider></v-divider>
            <v-list-item>
              <v-select
                v-model="team"
                :items="items"
                label="Select Team"
                prepend-icon="mdi-account-group"
                @change="selectTeam"
                hide-details
              ></v-select>
            </v-list-item>
            <v-list-item>
              <v-text-field
                v-model="search"
                label="Search Products"
                prepend-icon="mdi-magnify"
                v-on:keyup="searchProducts"
                clearable
                @click:clear="clearMessage"
                hide-details
              />
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="menu = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-sheet
      v-resize="onResize"
      :height="height"
      id="scrolling-techniques-7"
      class="overflow-y-auto"
    >
      <v-container style="margin-top: 70px; margin-bottom: 70px; padding: 0;">
        <v-card>
          <v-list three-line>
            <template v-for="(employee, index) in showEmployees">
              <v-lazy
                :key="index"
                min-height="100"
                transition="fade-transition"
              >
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox v-model="employee.selected"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-avatar size="48">
                    <v-img :src="employee.image"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content class="pl-4 text-left">
                    <v-list-item-title
                      v-text="employee.name"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-text="employee.email"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-text="employee.category"
                      class="font-weight-bold"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-menu bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-subheader>SELECT OPTION</v-subheader>
                        <v-list-item-group color="primary">
                          <v-list-item :href="`mailto:${employee.email}`">
                            <v-list-item-icon>
                              <v-icon color="primary">mdi-email</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              Email
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item :href="`tel:${employee.email}`">
                            <v-list-item-icon>
                              <v-icon color="primary">mdi-phone</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              Call
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              {{ employee.name }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
              </v-lazy>
              <v-divider
                v-if="index + 1 < showEmployees.length"
                :key="`divider-${index}`"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-container>
    </v-sheet>
    <v-btn
      class="mx-2"
      fab
      dark
      absolute
      right
      color="indigo"
      style="bottom: 10px;"
      @click="dialog = !dialog"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import Api from '@/services/Api'

// const pdfMake = require('pdfmake/build/pdfmake.js')
// const pdfFonts = require('pdfmake/build/vfs_fonts.js')
// pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  name: 'employees',

  data: () => ({
    dialog: false,
    disable: true,
    employees: [],
    height: 400,
    indeterminate: false,
    items: [
      'All',
      'Officers',
      'Leadership',
      'Sales',
      'Creative',
      'Sales & Creative',
      'Fulfillment',
      'Other'
    ],
    loading: true,
    menu: false,
    numberSelected: 'Select All',
    search: '',
    selectAll: false,
    selected: [],
    showEmployees: [],
    team: '',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.'
  }),

  created () {
    this.getEmployees()
  },

  mounted () {
    this.onResize()

    // this.$getLocation({
    //   enableHighAccuracy: true, //defaults to false
    //   timeout: Infinity, //defaults to Infinity
    //   maximumAge: 0, //defaults to 0
    // }).then(coordinates => {
    //   console.log('coordinates', coordinates)
    // })

    // fetch('https://api.ipify.org?format=json')
    //   .then(x => x.json())
    //   .then(({ ip }) => {
    //     console.log('ip', ip)
    //   })
  },

  watch: {
    showEmployees: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        this.loading = true
        this.selected = this._.filter(this.showEmployees, ['selected', true])

        const notSelected = this._.filter(this.showEmployees, [
          'selected',
          false
        ])

        if (this.selected === undefined || this.selected.length === 0) {
          this.indeterminate = false
          this.selectAll = false
        } else {
          if (notSelected === undefined || notSelected.length === 0) {
            this.selectAll = true
          } else {
            this.selectAll = false
          }

          if (!this.selectAll) {
            this.indeterminate = true
          }
        }

        if (this.selected.length > 0) {
          this.numberSelected = '(' + this.selected.length + ' selected)'
          this.disable = false
        } else {
          this.numberSelected = 'Select All'
          this.disable = true
        }

        this.loading = false
      },
      deep: true
    }
  },

  methods: {
    onResize () {
      this.height = window.innerHeight - 120
    },

    async getEmployees () {
      try {
        const response = await Api().get('/all_users')

        const employees = response.data

        let row = {}
        const rows = []

        for (let i in employees) {
          row['id'] = employees[i].id
          row['name'] = employees[i].firstName
          row['email'] = employees[i].email
          row['image'] =
            process.env.VUE_APP_ENV_API +
            '/images/members/' +
            employees[i].image
          row['selected'] = false

          rows.push(row)
          row = {}
        }

        this.employees = rows
        this.showEmployees = rows
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    // async getEmployees() {
    //   try {
    //     const response = await axios.get(
    //       process.env.VUE_APP_ENV_API + '/get_allproducts'
    //     )

    //     const employees = response.data

    //     let row = {}
    //     const rows = []

    //     for (let i in employees) {
    //       row['id'] = employees[i].id
    //       row['name'] = employees[i].Ptitle
    //       row['email'] = employees[i].tagline
    //       row['image'] = employees[i].Pimage
    //       row['category'] = employees[i].Ppages
    //       row['selected'] = false

    //       rows.push(row)
    //       row = {}
    //     }

    //     this.employees = rows
    //     this.showEmployees = rows
    //     this.loading = false
    //   } catch (e) {
    //     console.error(e)
    //   }
    // },

    selectAllTeam () {
      if (this.indeterminate) {
        this.indeterminate = false
        this.selectAll = true
      }

      this.selectAll = !this.selectAll

      for (var i in this.showEmployees) {
        this.showEmployees[i].selected = this.selectAll
      }
    },

    searchProducts () {
      this.loading = true

      if (this.search) {
        if (this.search.length > 3) {
          let search = this.search.toLowerCase()
          this.team = 'All'

          let employees = this._.filter(this.employees, function (obj) {
            if (obj.name.toLowerCase().indexOf(search) !== -1) {
              return obj.name.toLowerCase().indexOf(search) !== -1
            }

            // if (obj.category.toLowerCase().indexOf(search) !== -1) {
            //   return obj.category.toLowerCase().indexOf(search) !== -1
            // }
          })

          this.showEmployees = employees
        }
      } else {
        this.showEmployees = this.employees
      }

      this.loading = false
    },

    selectTeam () {
      let employees = []
      let team = this.team.toLowerCase()
      team = team.split(' & ')

      if (team[0] === 'all') {
        this.showEmployees = this.employees
      } else {
        employees = this._.filter(this.employees, function (obj) {
          for (var i = 0; i < team.length; i++) {
            if (obj.category.toLowerCase().indexOf(team[i]) !== -1) {
              return obj.category.toLowerCase().indexOf(team[i]) !== -1
            }
          }
        })

        this.showEmployees = employees
      }
    },

    clearMessage () {
      this.search = ''
      this.showEmployees = this.employees
    }

    // async downloadPdf () {
    //   const response = await axios.get(
    //     process.env.VUE_APP_ENV_API + '/get_logo'
    //   )

    //   const logo = response.data

    //   const squareResponse = await axios.get(
    //     process.env.VUE_APP_ENV_API + '/get_square'
    //   )

    //   const square = squareResponse.data

    //   let docDefinition = {
    //     footer: function(currentPage, pageCount) {
    //       return currentPage.toString() + ' of ' + pageCount
    //     },

    //     content: [
    //       {
    //         image: 'data:image/jpeg;base64,' + logo,
    //         width: 200,
    //         alignment: 'center',
    //       },

    //       { text: 'Name', style: 'header' },

    //       {
    //         columns: [
    //           {
    //             image: 'data:image/jpeg;base64,' + square,
    //             width: 80,
    //             alignment: 'center',
    //           },
    //           {
    //             layout: 'lightHorizontalLines',
    //             table: {
    //               widths: ['*'],
    //               body: [[this.selected[0].name], [' ']],
    //             },
    //           },
    //         ],
    //       },

    //       {
    //         columns: [
    //           { text: 'Address:', width: '20%' },
    //           {
    //             layout: 'lightHorizontalLines',
    //             table: {
    //               widths: ['*'],
    //               body: [['123 First St.'], [' ']],
    //             },
    //           },
    //         ],
    //       },
    //     ],

    //     styles: {
    //       header: {
    //         fontSize: 18,
    //         bold: true,
    //         alignment: 'center',
    //         margin: [0, 50, 0, 50],
    //       },
    //     },
    //   }

    //   pdfMake.createPdf(docDefinition).download('optionalName.pdf')
    // },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Products.vue